import { render, staticRenderFns } from "./ContactListDialog.vue?vue&type=template&id=64b244c7&scoped=true"
import script from "./ContactListDialog.vue?vue&type=script&lang=js"
export * from "./ContactListDialog.vue?vue&type=script&lang=js"
import style0 from "./ContactListDialog.vue?vue&type=style&index=0&id=64b244c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b244c7",
  null
  
)

export default component.exports